module.exports = __webpack_public_path__ + "img/logo-with-name.25ddfabe.png";